import debounce from 'lodash.debounce'
import {FC, RefObject, useCallback, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import {Search, SearchProps} from './Search'
import {ms100} from 'definitions/constant'

interface SearchPortalProps extends SearchProps {
  parentRef: RefObject<HTMLElement>
  ariaLabel?: string
}
// This search portal component is useful when parent height is less than search dropdown.
// Basically we are rendering this child dropdown component outside the DOM hierarchy of the parent component
// TODO: Refactor this component to pass proper data-cy attributes to use them in tests.
export const SearchPortal: FC<SearchPortalProps> = ({
  callbackFunc,
  classes,
  isNoPadding,
  parentRef,
  placeholder,
  widthMultiplyBy = 1,
  isSelectedCategoryCustomized,
  ariaLabel = 'search',
}) => {
  // div element will be created only once
  const [searchContainerEl] = useState(document.createElement('div'))
  const parentRect = parentRef?.current?.getBoundingClientRect()

  useEffect(() => {
    const aParentRect = parentRef?.current?.getBoundingClientRect()
    searchContainerEl.id = 'user-group-search-container'
    searchContainerEl.style.position = 'absolute'
    searchContainerEl.style.top = `${aParentRect?.top}px`
    searchContainerEl.style.left = `${aParentRect?.left}px`
    searchContainerEl.style.width = `${aParentRect?.width}px`
  }, [parentRef])

  // this use effect is need to reposition the input element.
  // use case - delete all users of custom policy
  useEffect(() => {
    setSearchContainerEl(parentRect)
  }, [parentRect?.left])

  const setSearchContainerEl = useCallback(
    debounce(parentRectInput => {
      searchContainerEl.style.top = `${parentRectInput?.top}px`
      searchContainerEl.style.left = `${parentRectInput?.left}px`
    }, ms100),
    [],
  )

  useEffect(() => {
    const bodyElement = document.getElementsByTagName('body')[0]
    bodyElement.appendChild(searchContainerEl)

    return () => {
      bodyElement.removeChild(searchContainerEl)
    }
  }, [searchContainerEl])

  return createPortal(
    <Search
      callbackFunc={callbackFunc}
      classes={classes}
      isNoPadding={isNoPadding}
      placeholder={placeholder}
      widthMultiplyBy={widthMultiplyBy}
      parentWidth={parentRect?.width}
      isSelectedCategoryCustomized={isSelectedCategoryCustomized}
      ariaLabel={ariaLabel}
    />,
    searchContainerEl,
  )
}
